import { useEffect, useState } from 'react';

import { cNs } from 'src/helpers';

type HtmlPreviewProps = {
  className?: string;
  emptyContentClassName?: string;
  content?: string;
};

export function HtmlPreview({ className, emptyContentClassName, content }: Readonly<HtmlPreviewProps>) {
  const [frameContent, setFrameContent] = useState<string | null>(null);

  useEffect(() => {
    if (content) {
      const blob = new Blob([content], { type: 'text/html' });
      setFrameContent(URL.createObjectURL(blob));
    } else {
      setFrameContent(null);
    }
  }, [content]);

  return (
    <div className={cNs(className, !frameContent && emptyContentClassName)}>
      {frameContent ? <iframe src={frameContent} title="Preview" /> : null}
    </div>
  );
}
